import { render, staticRenderFns } from "./TempoProcesExpurgoSemestral.vue?vue&type=template&id=56760f8b&"
import script from "./TempoProcesExpurgoSemestral.vue?vue&type=script&lang=js&"
export * from "./TempoProcesExpurgoSemestral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports